import { render, staticRenderFns } from "./reservationStockDialog.vue?vue&type=template&id=66df4061&scoped=true"
import script from "./reservationStockDialog.vue?vue&type=script&lang=js"
export * from "./reservationStockDialog.vue?vue&type=script&lang=js"
import style0 from "./reservationStockDialog.vue?vue&type=style&index=0&id=66df4061&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66df4061",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66df4061')) {
      api.createRecord('66df4061', component.options)
    } else {
      api.reload('66df4061', component.options)
    }
    module.hot.accept("./reservationStockDialog.vue?vue&type=template&id=66df4061&scoped=true", function () {
      api.rerender('66df4061', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/reservationStockDialog.vue"
export default component.exports